import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";
export default function HotelIcon({ color = "offWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
    >
      <path
        d="M5.00004 0.833313C4.38171 0.833313 3.83337 1.07831 3.35504 1.53331C2.87671 1.98831 2.66671 2.52498 2.66671 3.16665V6.66665C2.02504 6.66665 1.50004 6.88831 1.03337 7.35498C0.566707 7.82165 0.333374 8.38165 0.333374 8.99998V14.8333H1.88504L2.66671 17.1666H3.83337L4.61504 14.8333H19.385L20.1667 17.1666H21.3334L22.115 14.8333H23.6667V8.99998C23.6667 8.38165 23.4217 7.83331 22.9667 7.35498C22.5 6.88831 21.975 6.66665 21.3334 6.66665V3.16665C21.3334 2.52498 21.1117 1.99998 20.645 1.53331C20.1784 1.06665 19.6184 0.833313 19 0.833313M5.00004 3.16665H10.8334V6.66665H5.00004M13.1667 3.16665H19V6.66665H13.1667V3.16665Z"
        fill="#14141E"
      />
    </svg>
  );
}
